import { Component, OnDestroy } from '@angular/core';
import { Subject, takeWhile } from 'rxjs';
import { DialogService } from 'primeng/dynamicdialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { IQuery, QueryService } from '@app/core/queries';
import { YesNoDialogComponent } from '@app/shared';
import { LABORATORY_TYPES, laboratoryTypes } from '../../query-basic/query-basic/estudios-clinicos.options';

@Component({
  selector: 'app-query-manager',
  templateUrl: './query-manager.component.html',
  styleUrls: ['./query-manager.component.css'],
})
export class QueryManagerComponent implements OnDestroy {
  public records$: Subject<IQuery[]>;
  public selectedRecords: IQuery[];
  public labTypeFilterOptions: { label: string; value: string }[];

  private destroyed: boolean;

  constructor(
    private router: Router,
    private service: QueryService,
    private dialogService: DialogService,
    private translate: TranslateService
  ) {
    this.records$ = new Subject();
    this.labTypeFilterOptions = laboratoryTypes.map((lab) => ({
      label: this.translate.instant(`QUERY.TYPE_${lab.id}`),
      value: lab.id,
    }));
    this.loadRecords();
  }

  private loadRecords(): void {
    this.selectedRecords = [];

    this.service
      .getList()
      .pipe(takeWhile(() => !this.destroyed))
      .subscribe((records) => {
        this.records$.next(records);
      });
  }

  public deleteSelected(): void {
    this.dialogService
      .open(YesNoDialogComponent, {
        height: '300px',
        width: '300px',
        header: 'Eliminar query/es',
        data: {
          message: '¿Eliminar queries seleccionadas?',
        },
      })
      .onClose.pipe(takeWhile(() => !this.destroyed))
      .subscribe((result) => {
        if (result) {
          this.service
            .deleteQuery(this.selectedRecords.map((r) => r.id))
            .pipe(takeWhile(() => !this.destroyed))
            .subscribe(() => {
              this.loadRecords();
            });
        }
      });
  }

  public onRowEdit(record: IQuery): void {
    this.router.navigateByUrl(`/query/${record.id}`);
  }

  public onRowShow(record: IQuery): void {
    this.router.navigateByUrl(`/query/results/${record.id}`);
  }

  public newRecord(): void {
    this.router.navigateByUrl('/query/new');
  }

  public hasHistoricData(record: IQuery): boolean {
    return !!record.historicDatabaseName;
  }

  public isDemographicDataOnly(record: IQuery): boolean {
    try {
      const parsedData = JSON.parse(record.data);
      return parsedData.demographicDataOnly === true;
    } catch (error) {
      return false;
    }
  }

  public getLabTypeIcon(record: IQuery): string {
    if (record.labType === LABORATORY_TYPES.General) {
      return '/assets/icons/flask.svg';
    } else if (record.labType === LABORATORY_TYPES.Micro) {
      return '/assets/icons/microbe.svg';
    }
    return 'pi pi-question-circle';
  }

  public getLabTypeTitle(record: IQuery): string {
    return `QUERY.TYPE_${record.labType}`;
  }

  public ngOnDestroy(): void {
    this.destroyed = true;
  }
}
